export default __webpack_public_path__ + "static/media/Camilo_Falla.6139f23e.png";